import classNames from "classnames";
import React from "react";

import Icon from "@components/atoms/Icon";

import { IconName } from "@const/enum";

export interface IProps {
  name: string;
  showIcon: boolean;
  value?: string | number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string | classNames.ArgumentArray;
}

function ButtonMenu({ name, value, onClick, showIcon, className }: IProps) {
  return (
    <button
      className={classNames("flex items-center whitespace-nowrap px-2.5", className)}
      onClick={onClick}
      type="button"
      value={value}
    >
      {showIcon ? <Icon className="pointer-events-none mb-px inline-block" name={IconName.Default_700} /> : null}
      {name}
    </button>
  );
}

export default ButtonMenu;
